import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    zIndex: 30,
    display: 'flex',
    flex: '0 0 auto',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    backgroundColor: theme.palette.background.default,
    height: theme.spacing(7.5),
    borderBottom: `${theme.spacing(0.125)} solid #000`,
    alignItems: 'stretch',
  },

  container: {
    flexFlow: 'row nowrap',
    flex: '1 1 0px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(0, 3.75),
    backgroundColor: '#1b1c1f',

    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0),
    },
  },

  navigationControls: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(3),
  },

  backButton: {
    paddingRight: theme.spacing(1),
    cursor: 'pointer',
  },

  playersOnline: {
    textTransform: 'uppercase',
    fontSize: theme.spacing(2.25),
    fontFamily: '"Bebas Neue",cursive',
    letterSpacing: '.05em',
  },

  profileMenuContainer: {
    display: 'flex',
    cursor: 'pointer',
    flexFlow: 'row nowrap',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    padding: 0,

    [theme.breakpoints.down('lg')]: {
      width: 'auto',
      backgroundColor: theme.palette.background.default,
    },
  },
}));
